export enum BulkUploadTemplateType {
  STORAGE = "STORAGE",
  STORAGE_INTL = "STORAGE_INTL",
  REPLENISHMENT = "REPLENISHMENT",
  REPLENISHMENT_EACHES = "REPLENISHMENT_EACHES",
  INDIVIDUAL = "INDIVIDUAL",
  INDIVIDUAL_ENHANCED_WITH_LOT_TRACKING = "INDIVIDUAL_ENHANCED_WITH_LOT_TRACKING",
  CASE_PACK_WITH_LOT_TRACKING = "CASE_PACK_WITH_LOT_TRACKING",
}
